<template>
  <div id="app">
    <template v-if="!authenticated">
      <!-- Show 2FA verification page if on that route -->
      <two-factor-verify v-if="is2FARoute" />
      <!-- Use custom LoginPage when not authenticated -->
      <login-page v-else />
    </template>
    
    <template v-else-if="authenticated && dashboardReady">
      <!-- Use dashboard only when authenticated and ready -->
      <dashboard :class="ismonitor">
        <template slot="header-dropdown-menu">
          <a href="#" class="dropdown-item" @click.prevent="open2FAModal">
            {{ $t("twoFactor.title") || "Two-Factor Authentication" }}
          </a>
          <a href="#" class="dropdown-item" @click.prevent="openModal">
            {{ $t("changePassword") }}
          </a>
        </template>
      </dashboard>
    </template>
    
    <template v-else>
      <!-- Loading state while preparing dashboard -->
      <div class="auth-loading">
        <div class="spinner"></div>
      </div>
    </template>

    <div id="alert_placement"></div>

    <modal v-for="alert in alerts" :key="alert.id" :show.sync="alert.show">
      <div>
        <div
          style="
            background-color: #fa9b34;
            padding: 20px;
            font-size: larger;
            font-weight: bold;
            color: white;
          "
        >
          {{ $t("warning") }}
        </div>
        <div
          style="
            background-color: #ffffff;
            padding: 12px;
            font-size: larger;
            font-weight: bold;
          "
        >
          {{ alert.title }}
        </div>
        <div style="background-color: #ffffff; padding: 12px">
          {{ alert.description }}
        </div>
      </div>
    </modal>
    <!-- Change Password Modal -->
    <change-password-modal
      v-if="modal"
      :show.sync="modal"
      :user="user"
      @password-changed="handlePasswordChanged"
    />

    <!-- Two-Factor Settings Modal -->
    <two-factor-settings-modal
      v-if="twoFactorModal"
      :show.sync="twoFactorModal"
    />

    <!-- Enhanced Notifications for Authentication -->
    <enhanced-notifications />

    <!-- Toast Notifications -->
    <toast-container ref="toastContainer" />

    <!-- Logout Confirmation Dialog -->
    <logout-confirmation
      :show="logoutConfirmationShow"
      @confirm="handleLogoutConfirm"
      @cancel="handleLogoutCancel"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import EnhancedNotifications from "./components/EnhancedNotifications.vue";
import ToastContainer from "./components/ToastContainer.vue";
import LogoutConfirmation from "./components/LogoutConfirmation.vue";
import LoginPage from "./views/LoginPage.vue";
import TwoFactorVerify from "./views/TwoFactorVerify.vue";
import ChangePasswordModal from "./components/ChangePasswordModal.vue";
import TwoFactorSettingsModal from "./components/TwoFactorSettingsModal.vue";

export default {
  components: {
    EnhancedNotifications,
    ToastContainer,
    LogoutConfirmation,
    LoginPage,
    TwoFactorVerify,
    ChangePasswordModal,
    TwoFactorSettingsModal
  },
  data() {
    return {
      modal: false,
      twoFactorModal: false,
      alerts: [],
      alert_count: 0,
      dashboardReady: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters["authentication/user"];
    },
    authenticated() {
      return this.$store.getters["authentication/authenticated"];
    },
    is2FARoute() {
      return this.$route && this.$route.path === '/2fa-verify';
    },
    ismonitor() {
      var user = this.$store.getters["authentication/user"];
      if (user.id() === "soc@cyradar.com") {
        return "soc-monitor";
      }
      return "";
    },
    logoutConfirmationShow() {
      return this.$store.state.logoutConfirmation && this.$store.state.logoutConfirmation.show;
    },
  },
  watch: {
    authenticated(newVal) {
      if (newVal) {
        // When authenticated becomes true, set dashboardReady after a short delay
        setTimeout(() => {
          this.dashboardReady = true;
        }, 100);
      } else {
        // When logged out, reset dashboardReady
        this.dashboardReady = false;
      }
    }
  },
  async mounted() {
    // Set dashboardReady to true after a short delay if already authenticated
    if (this.authenticated) {
      this.$nextTick(() => {
        this.dashboardReady = true;
      });
    }
    
    // Make toast globally accessible
    Vue.prototype.$toast = (message, type = 'info', duration = 3000) => {
      if (this.$refs.toastContainer) {
        this.$refs.toastContainer.addToast(message, type, duration);
      }
    };
    
    const audio = new Audio("/alert.mp3");
    const result = await Notification.requestPermission();
    const isPermiited = result === "granted";

    // if (result === "denied") {
    //   this.$store.dispatch("NOTIFY", {
    //     type: "warning",
    //     error: {
    //       message: this.$t("Thông báo đã bị chặn."),
    //     },
    //   });
    // }

    // this.$store.dispatch("NOTIFY", {
    //   type: "success",
    //   text: this.$t("Đã bật thông báo cho trình duyệt của bạn."),
    // });

    const eventSource = new EventSource("/alert/socket");
    eventSource.addEventListener("alert", (event) => {
      const data = JSON.parse(event.data);
      isPermiited &&
        new Notification(`Cảnh báo ${data.title}`, {
          body: data.title + " " + data.description,
        });

      this.alerts.push({ ...data, id: this.alert_count, show: true });
      this.alert_count++;

      audio.play();
    });

  },
  methods: {
    openModal() {
      this.modal = true;
    },
    open2FAModal() {
      this.twoFactorModal = true;
    },
    handlePasswordChanged() {
      // Password changed successfully, modal will close automatically
    },

    /**
     * Handles the confirmation of logout action
     */
    handleLogoutConfirm() {
      // Hide the confirmation dialog using proper Vuex action
      this.$store.dispatch('hideLogoutConfirmation');
      // Dispatch the logout action with confirmed flag to bypass the confirmation
      this.$store.dispatch('LOGOUT', { confirmed: true });
    },

    /**
     * Handles the cancellation of logout action
     */
    handleLogoutCancel() {
      // Hide the confirmation dialog using proper Vuex action
      this.$store.dispatch('hideLogoutConfirmation');
      // No further action needed - user stays logged in
    },
  },
};
</script>
<style src="@cyradar/ui/dist/ui.css"></style>
<style lang="scss">
$x: #1f2128;
$x-light: lighten($x, 5%);
$y: #dddddf;
$y-dark: darken($y, 5%);

.section {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  > .title {
    margin-bottom: 0rem !important;
    > .subtitle {
      margin-bottom: 0 !important;
    }
  }
}

.table {
  background-color: #fff;
  color: #363636;
  td,
  th {
    border: 1px solid #dbdbdb;
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: top;
  }
  thead {
    background-color: transparent;
    td,
    th {
      border-width: 0 0 2px;
      color: #363636;
    }
  }
  &.is-fullwidth {
    width: 100%;
  }
  &.is-striped {
    tbody {
      tr:nth-child(even) {
        background-color: #f0f1fa;
      }
    }
  }
  &.is-narrow {
    td,
    th {
      padding: 0.25em 0.5em;
    }
  }
}

.is-square {
  border-radius: 0 !important;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.switch[type="checkbox"] {
  & + label {
    display: inline-flex;
    padding-top: 0;
    line-height: 1.875rem;
    padding-left: 4.5rem;

    &:before {
      height: 1.875rem;
      width: 4rem;
    }

    &:after {
      height: 1.35rem;
      width: 1.35rem;
    }
  }

  &:checked + label {
    &:after {
      left: 2.4rem;
    }
  }
}

.input--simple {
  padding: 0.25em 0;
  font-size: 1rem;
  width: 100%;
  border: none;
  outline: none;
  box-shadow: none;
  border-bottom: 1px dashed #bbb;
  background-color: transparent !important;

  .dashboard.is-dark & {
    color: $y;
    border-color: lighten($x-light, 20%);
  }

  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }

  &.is-small {
    font-size: 0.75rem;
  }
}

.is-color-blue {
  $color: #004085;
  $bg: #cce5ff;

  color: $color !important;
  background-color: $bg !important;
  border-color: darken($bg, 10%) !important;

  .box__header {
    border-color: darken($bg, 10%) !important;
  }

  .input--simple,
  .button.is-text {
    color: $color !important;
  }

  .popover__ref .button {
    color: $color !important;
    background-color: darken($bg, 10%) !important;
    border-color: darken($bg, 15%) !important;
  }
}

.is-color-green {
  $color: #155724;
  $bg: #d4edda;

  color: $color !important;
  background-color: $bg !important;
  border-color: darken($bg, 10%) !important;

  .box__header {
    border-color: darken($bg, 10%) !important;
  }

  .input--simple,
  .button.is-text {
    color: $color !important;
  }

  .popover__ref .button {
    color: $color !important;
    background-color: darken($bg, 10%) !important;
    border-color: darken($bg, 15%) !important;
  }
}

.is-color-yellow {
  $color: #856404;
  $bg: #fff3cd;

  color: $color !important;
  background-color: $bg !important;
  border-color: darken($bg, 15%) !important;

  .box__header {
    border-color: darken($bg, 15%) !important;
  }

  .input--simple,
  .button.is-text {
    color: $color !important;
  }

  .popover__ref .button {
    color: $color !important;
    background-color: darken($bg, 15%) !important;
    border-color: darken($bg, 20%) !important;
  }
}

.is-color-red {
  $color: #721c24;
  $bg: #f8d7da;

  color: $color !important;
  background-color: $bg !important;
  border-color: darken($bg, 10%) !important;

  .box__header {
    border-color: darken($bg, 10%) !important;
  }

  .input--simple,
  .button.is-text {
    color: $color !important;
  }

  .popover__ref .button {
    color: $color !important;
    background-color: darken($bg, 10%) !important;
    border-color: darken($bg, 15%) !important;
  }
}

.is-color-teal {
  $color: #0c5460;
  $bg: #d1ecf1;

  color: $color !important;
  background-color: $bg !important;
  border-color: darken($bg, 10%) !important;

  .box__header {
    border-color: darken($bg, 10%) !important;
  }

  .input--simple,
  .button.is-text {
    color: $color !important;
  }

  .popover__ref .button {
    color: $color !important;
    background-color: darken($bg, 10%) !important;
    border-color: darken($bg, 15%) !important;
  }
}

.dashboard.is-dark {
  .vs__search {
    color: darken($y, 15%);
  }

  .vs__actions {
    svg {
      fill: darken($y, 15%);
    }
  }
}

.navbar-custom-instance {
  font-weight: 900;
  font-size: 20px;
  color: #f8aa0f !important;
  &:hover,
  &:focus {
    background-color: transparent !important;
  }
}

.soc-monitor {
  .navbar-custom-instance {
    font-size: 40px;
  }
  .navbar-item img {
    max-height: 2.75rem;
  }
  .main {
    margin-top: 1.5rem;
  }
  .sidebar {
    top: 4.5rem;
  }
  .navbar-burger {
    margin-top: 1rem;
  }
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.stepper {
  display: flex;
  width: 100%;
  padding-bottom: 1rem;
}
.stepper-item {
  display: inline-block;
  width: 50%;
  cursor: pointer;
  border-bottom-width: 5px;
  border-bottom-style: solid;
  border-bottom-color: #8a8a8a;
  text-align: center;
  .steper-header {
    color: #8a8a8a;
    font-weight: bolder;
  }
}

.stepper-done {
  border-bottom-color: #3298dc;
  .steper-header {
    color: #3298dc;
  }
}

.stepper-active {
  border-bottom-color: #3273dc;
  .steper-header {
    color: #3273dc;
  }
}
.lable-inline {
  padding: 0.2rem;
}
.field-line {
  width: 100%;
  padding: 0.2rem 0.2rem 0.75rem 0.2rem;
  display: flex;
}

.field-2 {
  width: 50%;
  padding-right: 0.2rem;
  display: inline-block;
}
#deadline-btn {
  width: 45px;
  height: 34px;
  padding: 0.2rem;
  padding-left: 0.4rem;
}
.field-auto {
  display: inline-block;
}
.group-field {
  margin-bottom: 0.75rem;
  width: 100%;
  display: flex;
}

/* Authentication loading state */
.auth-loading {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6b8cae;
}

.dashboard.is-dark ~ .auth-loading {
  background-color: #2b3544;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>
